import logo from "@assets/images/sg-courts-logo.png";
import Login from "./jds/Login";
import { useAuth } from "@hooks/useAuth";
import environment from "environment";
function Header() {
  const { user, logout } = useAuth();
  //const lipHeaderSettings = window.probate_setting.LIPHeaderSettings;
  return (
    <>
      {/* <a href="" id="scroll-to-top" title="Scroll to Top"><i className="fas fa-chevron-up"></i></a> */}
      {/* 
        <div className="sgds-masthead">
            <div className="container">
                <a href="https://www.gov.sg" target="_blank" rel="noreferrer">
                    <span className="sgds-icon sgds-icon-sg-crest"></span>
                    <span className="is-text">A Singapore Government Agency Website</span>
                </a>
            </div>
        </div> */}
      <div
        className="sgds-masthead"
        role="region"
        aria-label="Singapore Government agency identification"
      >
        <div className="container">
          <a href="https://www.gov.sg" target="_blank" rel="noreferrer">
            <span className="sgds-icon sgds-icon-sg-crest"></span>
            <span className="is-text">
              A Singapore Government Agency Website
            </span>
          </a>
        </div>
      </div>
      <header className="navbar-container">
        <nav className="navbar navbar-expand-lg">
     
          <div className="container">
            <a className="navbar-brand" href={environment.baseurl}>
              <img src={logo} alt="Logo" />
            </a>

            {user && <Login username={user.username} logout={logout} />}
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
